import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { setSuperRegion } from 'Store/Organization/SuperRegion/SuperRegionActions';
import { GET_SUPER_REGION } from 'Store/Organization/SuperRegion/SuperRegionType';
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* getSuperRegionSaga(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/dropdown/superregion/${req.divisionCode}`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setSuperRegion(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetSuperRegion() {
    yield takeEvery(GET_SUPER_REGION, getSuperRegionSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetSuperRegion()
    ])
}
